import { render, staticRenderFns } from "./PageEditorAlert.vue?vue&type=template&id=eaa2f146&scoped=true&"
import script from "./PageEditorAlert.vue?vue&type=script&lang=js&"
export * from "./PageEditorAlert.vue?vue&type=script&lang=js&"
import style0 from "./PageEditorAlert.vue?vue&type=style&index=0&id=eaa2f146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa2f146",
  null
  
)

export default component.exports